/** Price changes (F-RPT-N46): GET /admin/expenses/price-changes. */
export interface PriceChange {
  stock_item_id: string
  name: string
  unit: string
  vendor: string
  prev_unit_cost: number
  cur_unit_cost: number
  change_pct: number
  cur_qty: number
  extra_cost: number
  cur_buys: number
  last_bought_on: string
  baseline: 'previous_period' | 'last_buy'
  baseline_date?: string
}

export interface PriceChangesReport {
  from: string
  to: string
  previous_from: string
  previous_to: string
  threshold_pct: number
  changes: PriceChange[]
  extra_cost: number
  saved: number
}

/** A line's price against the last price paid, for the receipt review hint. */
export function lastPriceHint(
  unitPrice: number,
  last: { cost?: number; on?: string },
): { jump: 'up' | 'down' | null; pct: number } | null {
  if (!last.cost || last.cost <= 0) return null
  const pct = unitPrice > 0 ? ((unitPrice - last.cost) / last.cost) * 100 : 0
  const jump = Math.abs(pct) >= 10 ? (pct > 0 ? 'up' : 'down') : null
  return { jump, pct: Math.round(pct) }
}

/** The YYYY-MM-DD `days` days before `to` (inclusive window). */
export function windowStart(to: string, days: number): string {
  const d = new Date(`${to}T12:00:00`)
  d.setDate(d.getDate() - (days - 1))
  const p = (n: number) => String(n).padStart(2, '0')
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`
}
